const message = {
  msg_1: '技术参数',
  msg_2: '技术参数',
}

export default message